import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageProvider";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const WhyUs = () => {
  const { t } = useLang();

  return (
    <section
      data-testid="why-section"
      className="relative bg-[#0B1416] text-[#F5F1E8] py-28 md:py-40 overflow-hidden"
    >
      {/* Ambient turquoise glow */}
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-[#1BB6B9]/10 blur-[120px] pointer-events-none" />
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#0D7A7D]/15 blur-[120px] pointer-events-none" />

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end"
        >
          <div className="lg:col-span-5">
            <div className="overline text-[#6EE3E6]">— {t.why.eyebrow}</div>
            <h2
              data-testid="why-title"
              className="font-heading-tight text-5xl md:text-6xl lg:text-7xl leading-[0.95] mt-6"
            >
              {t.why.title}
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pl-16">
            <p className="text-lg font-light opacity-70 max-w-xl">
              {t.hero.lede}
            </p>
          </div>
        </motion.div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 border-t border-[#F5F1E8]/12">
          {t.why.items.map((item, i) => (
            <motion.div
              key={i}
              data-testid={`why-item-${i}`}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              custom={i}
              className={`p-8 md:p-10 border-b border-[#F5F1E8]/12 ${
                i < 4 ? "lg:border-r lg:border-[#F5F1E8]/12" : ""
              } ${i === 3 || i === 1 ? "md:border-r-0" : "md:border-r md:border-[#F5F1E8]/12"}`}
            >
              <div className="font-italiana text-[#1BB6B9] text-3xl mb-6">
                0{i + 1}
              </div>
              <div className="font-heading text-2xl md:text-3xl leading-tight">
                {item.t}
              </div>
              <div className="text-sm font-light opacity-65 mt-4 leading-relaxed">
                {item.d}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
